"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SocialButtonStyled = exports.ChannelIconContainerStyled = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _colors = require("../style/colors");
var _style = require("../Button/style");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function calculateBgColor(channel) {
  switch (channel) {
    case 'instagram':
      return _colors.instagramDark;
    case 'twitter':
      return _colors.twitterDark;
    case 'facebook':
      return _colors.facebookDark;
    case 'pinterest':
      return _colors.pinterestDark;
    case 'linkedin':
      return _colors.linkedinDark;
    default:
      return 'gray';
  }
}
const SocialButtonStyled = exports.SocialButtonStyled = /*#__PURE__*/_styledComponents.default.button.withConfig({
  displayName: "style__SocialButtonStyled",
  componentId: "bufferapp-ui__sc-xfbw5x-0"
})(["", ";", ";background-color:", ";color:", ";width:100%;justify-content:space-between;cursor:", ";box-shadow:0px 2px 10px rgba(0,0,0,0);transition:box-shadow 0.1s ease;p{color:", ";margin-left:8px;line-height:normal;}&:hover{box-shadow:0px 2px 10px rgba(0,0,0,0.25);transition:box-shadow 0.1s ease;}"], _style.ButtonBase, _style.large, props => calculateBgColor(props.channel), _colors.white, props => props.disabled ? 'not-allowed' : 'pointer', _colors.white);
const ChannelIconContainerStyled = exports.ChannelIconContainerStyled = /*#__PURE__*/_styledComponents.default.span.withConfig({
  displayName: "style__ChannelIconContainerStyled",
  componentId: "bufferapp-ui__sc-xfbw5x-1"
})(["display:flex;align-items:center;"]);